import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Envelope } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { PaginatedResponse } from '../../types/PaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';
import { EnvelopesSearchParams } from '../types/EnvelopesSearchParams';

export const getEnvelopes = (
  constructGet: ConstructGet,
  documentId: string,
  searchParams?: EnvelopesSearchParams,
): Promise<PaginatedResponse<Envelope[]> | undefined> =>
  constructGet<PaginatedResponse<Envelope[]>>(
    `${SIGNATURE_BASE_PATH}/envelope`,
    { params: { document_id: documentId, ...searchParams } },
    { transformerSet: TransformerSet.PreserveKeys },
  );
